<template ref="addTab">
<div class="zujian">	
	<div style="margin-bottom:20px;">
		<Button type="success" @click="showCateFun(0)">添加</Button>
	</div>
	<div class="">
		<Table :columns="columns" :data="tabList"></Table>
	</div>
    <div class="drawer-footer">
        <Button style="margin-right: 8px" @click="cancleFun">取消</Button>
        <Button type="primary" @click="activityAdd">确定</Button>
    </div>
	<Modal
		v-model="showCateStatus"
		:mask-closable="false"
		@on-ok="tianjiaFun"
        @on-cancel="showCateStatus=false"
		title="分类">
		<Input v-model="tabName" placeholder="请输入..." style="width: 300px" />
	</Modal>
</div>
</template>

<script>
import UploadThumb from "../../common/thumb";
export default {
    name: "",
    data() {
        return {
			is_edit: false, // 小分类编辑
			zhuanti_id: null,
			block_id: null,
            tabName: "",
			tabList: [],
			showCateStatus: false,
			columns: [
				{
					title: "名称",
					key: "content"
				},
				{
					title: "操作",
					key: "action",
					render: (h,params)=>{
						return h("div",[
							h("Button",{
								style: {
									marginRight: "8px"
								},
								props: {
									type: "success",
									size: "small"
								},
								on: {
									click: () => {
										this.showCateFun(1,params.row);
									}
								}
							},"编辑"),
							h("Button",{
								props: {
									type: "error",
									size: "small"
								},
								on: {
									click: () => {
										this.delFun(params.index,params.row);
									}
								}
							},"删除")
						])
					}
				}
			]
        }
    },
    // 计算
    computed: {},
    // 监听
    watch: {},
    components: {
        UploadThumb
    },
    created: function () {

    },
    methods: {
		// 初始化
		initFun(status,zhuanti_id,params){
			this.tabName = "";
			this.tabList = [];
			this.zhuanti_id = zhuanti_id;
			this.block_id = null;
			this.is_edit = false;
			if(status == 1){
				this.detailFun(params);
			}
		},
        // 取消
        cancleFun() {
            this.$emit("showTab", -1);
			this.$emit("updateContent");
        },
        // 确定
        activityAdd() {
			if(this.tabList.length == 0){
				this.$Message.warning("内容为空！");
				return;
			};
			
			if(this.block_id){
				this.$emit("updateContent");
			}else{
				let arr = [];
				for(let i in this.tabList){
					arr.push(this.tabList[i].content)
				};
				let params = {
					zhuanti_id: this.zhuanti_id,
					content: JSON.stringify(arr),
					type_id: 3
				};
				this.$api.zhuanti.blockcreate(params).then(res=>{
					if(res.code == 200){
						this.$emit("updateContent");
					}else{
						this.$Message.error(res.msg)
					}
				})
			}
        },
		// 详情
        detailFun(params) {
            console.log("详情", params);
			this.block_id = params.block_id;
			this.tabList = params.cate;
        },
		// 小分类
		showCateFun(status,item){
			this.showCateStatus = !this.showCateStatus;
			if(status == 1){
				// 编辑
				this.is_edit = true;
				this.currentItem = item;
				this.tabName = item.content;
			}else{
				// 新增
				this.tabName = "";
				this.is_edit = false;
			}
		},
		// 添加小分类
		tianjiaFun(){
			if(!this.tabName){
				this.$Message.warning("请填写内容！");
				return;
			}else{
				// 已有模块时
				if(this.block_id){
					// 新增
					if(!this.is_edit){
						let params = {
							block_id: this.block_id,
							content: this.tabName
						};
						this.$api.zhuanti.blockcatecreate(params).then(res=>{
							if(res.code == 200){
								let obj = {
									content: this.tabName,
									cate_id: res.result
								};
								this.tabList.push(obj);
								this.tabName = "";
							}else{
								this.$Message.error(res.msg)
							}
						})
					}else{
						// 编辑
						let params = {
							block_content_id: this.currentItem.cate_id,
							content: this.tabName
						};
						this.$api.zhuanti.blockedit(params).then(res=>{
							if(res.code == 200){	
								this.tabList[this.currentItem._index].content = this.tabName; // 更新小列表
								this.tabName = "";
							}else{
								this.$Message.error(res.msg)
							}
						})
					}
				}else{
					// 无模块时
					// 新增
					if(!this.is_edit){
						let obj = {
							content: this.tabName
						};
						this.tabList.push(obj);
						this.tabName = "";
					}else{
						// 编辑
						this.tabList[this.currentItem._index].content = this.tabName; // 更新小列表
						this.tabName = "";
					}
				}
			}
		},
		// 删除分类
		delFun(index,item){
			this.$Modal.confirm({
				title: "警告",
				content: "<p>此操作不可恢复，三思而后行...</p>",
				onOk: ()=>{
					if(this.block_id){
						// 删除
						let params = {
							block_content_id: item.cate_id
						}
						this.$api.zhuanti.blockremove(params).then(res=>{
							if(res.code == 200){
								this.tabList.splice(index,1);
							}else{
								this.$Message.error(res.msg)
							}
						})
					}else{
						this.tabList.splice(index,1);
					}
				}
			})			
		}
    }
}
</script>

<style>
.zujian img{
	max-width: 100%;
	display: block;
}
.typecontent {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10002;
}

.drawer-footer {
    padding-top: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

</style>
